export { PropositionThumbnailGroupBase } from './base/PropositionThumbnailGroupBase';
export {
    PropositionThumbnailGroupCms,
    PropositionThumbnailGroupCms as default,
} from './cms/PropositionThumbnailGroupCms';
